<template>
    <modal
        name="liberar-asientos-abonados"
        transition="pop-out"
        :width="modalWidth"
        :height="modalHeight"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Liberar los asientos de los abonados no renovados.</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 text-center">
                        <h1 class="font-weight-bold">¿Quieres liberar todos los asientos de los abonados que no hayan renovado?</h1>
                    </div>
                    <div class="col-12 text-center btn_lib">
                        <Button type="button" name="button" style="background-color: green" @click="liberarAsientosAbonados">SI, LIBERAR</Button>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        data() {
            return {
                modalWidth: '800px',
                modalHeight: 'auto'
            }
        },
        created() {
            this.adjustModalSize();
            window.addEventListener('resize', this.adjustModalSize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.adjustModalSize);
        },
        methods: {
            adjustModalSize() {
                if (window.innerWidth <= 768) {
                    this.modalWidth = '80%';
                    this.modalHeight = 'auto';
                } else {
                    this.modalWidth = '800px';
                    this.modalHeight = 'auto';
                }
            },
            close() {
                this.$emit('close', 'liberar-asientos-abonados');
            },
            liberarAsientosAbonados() {                
                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.liberar.asientos'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close();
                });
            }
        },
    }
</script>

<style scoped>
    h1 {
        font-size: 22px;
        margin-bottom: 24px;
    }

    h2 {
        font-size: 28px;
    }

    @media (max-width: 768px) {
        h1 {
            font-size: 20px;
        }

        h2 {
            font-size: 22px;
        }

        .btn_lib {
            margin-bottom: 20px;
        }
    }
</style>